import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-primary py-10" data-id="element-72" data-mp="207t4gfx6vxoq">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 text-center sm:px-6" data-id="element-73" data-mp="206rhpe6t9mr6">
        <p className="font-heading text-lg font-semibold text-white" data-id="element-74" data-mp="2f3ildznipkml">🏋️ Enciclopedia Pilates 360™</p>
        <p className="max-w-xl text-sm leading-relaxed text-white/70" data-id="element-75" data-mp="2a69yjlrfcsf0">
          El sistema de planificación N.º 1 para instructoras e instructores de Pilates de habla
          hispana. Más de 6.000 profesionales en 15 países confían en él.
        </p>
        <a href="mailto:manualeslistos@gmail.com" className="flex items-center gap-1.5 text-sm text-white/80 transition-colors hover:text-accent" data-id="element-76" data-mp="1w5pgwsx8x2n3">
          <MailIcon size={14} data-id="element-77" data-mp="1rdeftmqrrasy" />
          manualeslistos@gmail.com
        </a>
        <div className="mt-2 h-px w-full max-w-xs bg-white/15" aria-hidden="true" data-id="element-78" data-mp="13ntw31msk9im" />
        <p className="text-xs text-white/50" data-id="element-79" data-mp="ypsdehta2c7o">
          © Enciclopedia Pilates 360™ {new Date().getFullYear()} — Todos los derechos reservados.
        </p>
        <p className="text-xs text-white/40" data-id="element-80" data-mp="1ijfirsvm6cre">Prohibida la reproducción y redistribución sin autorización expresa.</p>
      </div>
    </footer>;
}